import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'vbTimespanToHours',
	standalone: false
})
export class VbTimespanToHoursPipe implements PipeTransform {
	public transform(milliseconds: number): number {
		return Math.round(milliseconds / 3.6e6);
	}
}
